var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E6FEEFD6-2800-4495-8FDC-3EEC240053EE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "20.0194885%",
    y1: "0%",
    x2: "91.6601687%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6200EE",
    stopOpacity: 0.101972247,
    offset: "0.0686233108%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC38BC",
    offset: "32.2714316%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7303C0",
    offset: "71.1412584%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6200EE",
    offset: "99.963049%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6200EE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.705,0.705 C7.31563925,0.315639251 6.68436075,0.315639251 6.295,0.705 L0.707106781,6.29289322 C0.316582489,6.68341751 0.316582489,7.31658249 0.707106781,7.70710678 L6.295,13.295 C6.68436075,13.6843607 7.31563925,13.6843607 7.705,13.295 C8.0944579,12.9055421 8.09472694,12.2741891 7.70560109,11.8843994 L3.83699312,8.0091918 L3.83699312,8.0091918 L12.9967756,8.0091918 C13.5490603,8.0091918 13.9967756,7.56147655 13.9967756,7.0091918 L13.9967756,7.00410481 C13.9967756,6.45182006 13.5490603,6.00410481 12.9967756,6.00410481 L3.82372549,6.00410481 L3.82372549,6.00410481 L7.70560158,2.11560106 C8.09472723,1.72581104 8.09445798,1.09445798 7.705,0.705 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doris-web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "K\\xE4ytt\\xE4j\\xE4n-muokkaus---k\\xE4ytt\\xF6oikeudet-v2",
    transform: "translate(-395.000000, -76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background/5%-pink",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "white-bg",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1280,
    height: 1400
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "url(#linearGradient-1)",
    opacity: 0.049999997,
    x: 0,
    y: 0,
    width: 1280,
    height: 1400
  })), /*#__PURE__*/React.createElement("g", {
    id: "UI/Container",
    transform: "translate(200.000000, 50.000000)",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeOpacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1056,-0.5 C1057.24264,-0.5 1058.36764,0.00367965644 1059.18198,0.818019485 C1059.99632,1.63235931 1060.5,2.75735931 1060.5,4 L1060.5,4 L1060.5,750 C1060.5,751.242641 1059.99632,752.367641 1059.18198,753.181981 C1058.36764,753.99632 1057.24264,754.5 1056,754.5 L1056,754.5 L4,754.5 C2.75735931,754.5 1.63235931,753.99632 0.818019485,753.181981 C0.00367965644,752.367641 -0.5,751.242641 -0.5,750 L-0.5,750 L-0.5,4 C-0.5,2.75735931 0.00367965644,1.63235931 0.818019485,0.818019485 C1.63235931,0.00367965644 2.75735931,-0.5 4,-0.5 L4,-0.5 Z",
    id: "Container"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UI/Buttons/Button-with-icon",
    transform: "translate(383.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Add-/-Filled",
    transform: "translate(17.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "-\\u21B3Color",
    fill: "#6200EE",
    xlinkHref: "#path-2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.7862827f78257f02c9bb821c999456d9.svg";
export { ForwardRef as ReactComponent };